/* eslint-disable @typescript-eslint/no-explicit-any */
// Shared constants for the simple widget registry entries.
// These mirror the constants in widgetRegistry.ts and are used by the
// category-specific registry files to avoid circular dependencies.

import {
  FiBarChart2,
  FiDollarSign,
  FiTrendingUp,
  FiClipboard,
  FiLifeBuoy,
  FiUsers,
  FiCpu,
  FiZap,
  FiCloud,
  FiCheckCircle,
  FiMonitor,
  FiActivity,
  FiTag,
  FiAlertTriangle,
  FiAlertOctagon,
  FiPackage,
  FiStar,
  FiXCircle,
  FiSearch,
  FiMessageSquare,
  FiEdit,
  FiTool,
  FiShield,
  FiClock,
  FiBriefcase,
  FiUser,
  FiTarget,
  FiHeart,
  FiArchive,
  FiLock,
  FiSettings,
  FiRefreshCw,
  FiPlay,
  FiDatabase,
  FiHash,
  FiAlertCircle,
  FiHelpCircle,
  FiMail,
  FiBell,
  FiTrendingDown,
  FiBookOpen,
  FiPhone,
  FiArrowUp,
  FiArrowDown,
  FiMaximize2,
  FiFileText,
  FiCrop,
  FiMoon,
  FiGrid,
  FiPieChart,
  FiAward
} from 'react-icons/fi';

export const REGISTRY_WIDGET_CATEGORIES = {
  HUB: 'Hub',
  HEALTH: 'Health',
  PLATFORMOPS: 'CloudOps',
  DATAOPS: 'DataOps',
  GENAIOPS: 'GenAIOps',
  AGENTOPS: 'AgentOps',
  AI_OPERATIONS: 'AI Operations',
  CUSTOM: 'Custom'
};

export const REGISTRY_WIDGET_SIZES = {
  SMALL: { w: 1, h: 1, minW: 1, minH: 1, maxW: 4, maxH: 4 },
  MEDIUM: { w: 2, h: 2, minW: 1, minH: 1, maxW: 4, maxH: 4 },
  LARGE: { w: 2, h: 3, minW: 2, minH: 2, maxW: 4, maxH: 4 },
  WIDE: { w: 4, h: 1, minW: 2, minH: 1, maxW: 4, maxH: 4 },
  FULL: { w: 4, h: 2, minW: 2, minH: 2, maxW: 4, maxH: 4 }
};

export const REGISTRY_WIDGET_TYPES = {
  METRIC: 'metric',
  CHART: 'chart',
  LIST: 'list',
  TABLE: 'table',
  CUSTOM: 'custom'
};

export const REGISTRY_ICONS = {
  FiBarChart2,
  FiDollarSign,
  FiTrendingUp,
  FiClipboard,
  FiLifeBuoy,
  FiUsers,
  FiCpu,
  FiZap,
  FiCloud,
  FiCheckCircle,
  FiMonitor,
  FiActivity,
  FiTag,
  FiAlertTriangle,
  FiAlertOctagon,
  FiPackage,
  FiStar,
  FiXCircle,
  FiSearch,
  FiMessageSquare,
  FiEdit,
  FiTool,
  FiShield,
  FiClock,
  FiBriefcase,
  FiUser,
  FiTarget,
  FiHeart,
  FiArchive,
  FiLock,
  FiSettings,
  FiRefreshCw,
  FiPlay,
  FiDatabase,
  FiHash,
  FiAlertCircle,
  FiHelpCircle,
  FiMail,
  FiBell,
  FiTrendingDown,
  FiBookOpen,
  FiPhone,
  FiArrowUp,
  FiArrowDown,
  FiMaximize2,
  FiFileText,
  FiCrop,
  FiMoon,
  FiGrid,
  FiPieChart,
  FiAward
};
